module.exports = __webpack_public_path__ + "static/media/17-jan21jun21.8b5ced6f.pdf";